


















































import { ref, defineComponent, toRefs, reactive } from '@vue/composition-api'

import { createLicense, editLicense } from '@/shared/api'

import CloseButton from '@/components/custom/CloseButton.vue'

export default defineComponent({
  name: 'EditLicense',
  components: {
    CloseButton,
  },
  props: {
    license: Object,
  },
  setup(props, context) {
    const LicenseForm = ref(null)

    const data = reactive({
      valid: true,
      name: props.license ? props.license.name : '',
      isTeacherType: props.license ? props.license.isTeacherType : null,
      nameRules: [
        (v: string) => !!v || context.root.$t('LicenseForm.name.required'),
      ],
      typeRules: [
        (v: boolean | null) =>
          v !== null || context.root.$t('LicenseForm.type.required'),
      ],
    })
    const allowedTypes = [
      {
        value: true,
        label: context.root.$t('licenses.teacher'),
      },
      {
        value: false,
        label: context.root.$t('licenses.student'),
      },
    ]

    const loading = ref(false)

    const sendCreateLicenseRequest = async (
      name: string,
      isTeacherType: boolean
    ) => {
      loading.value = true
      try {
        const createdLicense = await createLicense(name, isTeacherType)
        context.emit('license-created', createdLicense)
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    const sendEditLicenseRequest = async (
      id: string,
      name: string,
      isTeacherType: boolean
    ) => {
      loading.value = true
      try {
        const editedLicense = await editLicense(id, name, isTeacherType)
        context.emit('license-edited', editedLicense)
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    const submit = (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = LicenseForm.value
      form.validate()
      if (!data.valid) {
        return
      }
      if (props.license) {
        sendEditLicenseRequest(props.license.id, data.name, data.isTeacherType)
        return
      }
      sendCreateLicenseRequest(data.name, data.isTeacherType)
    }

    return {
      ...toRefs(data),
      loading,
      LicenseForm,
      submit,
      allowedTypes,
    }
  },
})
